import { ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { Lookup } from '../../../shared-components/lookup/lookup.model';
import { LookupService } from '../../../shared-components/lookup/lookup.service';
import { SecurityService } from '../../../shared-components/security/security.service';
import { SpinnerService } from '../../../shared-components/spinner/spinner.service';
import { StudentService } from '../../../shared-components/student/student.service';
import { UserPermission } from '../../../shared-components/user/user-permission.model';
import { UserService } from '../../../shared-components/user/user.service';
import { YearService } from '../../../shared-components/year/year.service';
import { Assessment, TestMasterLayoutVersion } from '../../../student360/assessment/assessment.model';
import { AssessmentService } from '../../../student360/assessment/assessment.service';
import { AddAssessmentTabDialogComponent } from './add-assessment-tab-dialog/add-assessment-tab-dialog.component';
import { AssessmentDataCategory } from './assessment-data-category';


@Component({
  selector: 'app-assessment',
  templateUrl: './assessment.component.html',
  styleUrls: ['./assessment.component.css']
})
export class AssessmentComponent implements OnInit, OnDestroy {

  tabs: Assessment[];
  assessments: Assessment[];
  subscriptions: Subscription[] = [];
  tabNames: string[];
  tableDataV9: TylerMatTableDataSource[] = [];
  openDetailRows: Array<AssessmentDataCategory> = new Array<AssessmentDataCategory>();
  dataCategoriesV10: AssessmentDataCategory[];
  selectionIndex = 0;
  toggleAllRows: EventEmitter<boolean> = new EventEmitter<boolean>();
  selectedRow: AssessmentDataCategory;
  assessmentAndTabSubscriptions: Subscription[] = [];
  selectedTabName = '';
  previousTabSelection = '';
  processingTabs = false;
  triggerChanges = new EventEmitter<any>();
  testMasters: Lookup[] = [];
  testMasterLayoutVersions: TestMasterLayoutVersion[] = [];
  testMasterLayoutVersion: TestMasterLayoutVersion[] = [];
  TestMasterId: number;
  TestMasterLayoutVersionId: number;
  V9UserPermissions: UserPermission[] = [];
  userCanProcess: boolean;

  constructor(
    private assessmentService: AssessmentService,
    private studentService: StudentService,
    private userService: UserService,
    private yearService: YearService,
    private changeDetector: ChangeDetectorRef,
    private spinnerService: SpinnerService,
    private lookupService: LookupService,
    private router: Router,
    private dialog: MatDialog,
    private securityService: SecurityService,
  ) { }

  get filtered(): boolean {
    if (this.tableDataV9[this.selectionIndex]) {
      let filtered = this.tableDataV9[this.selectionIndex].isFiltered();
      for (let i = 0; i < this.tableDataV9[this.selectionIndex].data.length; i++) {
        const subTable = this.tableDataV9[this.selectionIndex].data[i];
        if (subTable instanceof AssessmentDataCategory && subTable.subTableData.isFiltered()) {
          filtered = true;
          break;
        }
      }
      return filtered;
    }
    return false;
  }


  // Event Functions
  ngOnInit() {
    // POST: subscribing to the necessary services
    this.getAssessmentsAndTabs();
    this.getTestMastersLookup();
    this.subscriptions.push(
      this.studentService.selectedStudentStream$.subscribe(() => {
        this.getAssessmentsAndTabs();
      }),
      this.yearService.observableStudent360YearStream$.subscribe(() => {
        this.previousTabSelection = this.selectedTabName;
        this.getAssessmentsAndTabs();
      }),
      this.toggleAllRows.subscribe(toggle => {
        if (this.tableDataV9[this.selectionIndex]) {
          this.tableDataV9[this.selectionIndex].expandAll(toggle);
          this.triggerChanges.emit();
        }
      })
    );

    this.V9UserPermissions = this.securityService.userPermissions;
    // Maintain Scores for Individual Students
    const userCanAdd = this.V9UserPermissions.filter(permission => (permission.PermissionCode == 'AS_MSFIS'))[0];
    if (userCanAdd != undefined && userCanAdd != null) {
      this.userCanProcess = true;
    }
  }

  getTestMastersLookup() {
    this.lookupService.getTestMastersLookup().subscribe(result => {
      this.testMasters = result;
      this.getTestMasterLayoutVersion();
    });
  }

  getTestMasterLayoutVersion() {
    this.assessmentService.getTestMasterLayoutVersion().subscribe(result => {
      this.testMasterLayoutVersions = result;
    });
  }

  setLayoutVersion(testMasterId: number) {
    this.testMasterLayoutVersion = this.testMasterLayoutVersions.filter(x => x.TestMasterId == testMasterId);
  }

  ngOnDestroy() {
    // POST: ends all subscriptions
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
    this.assessmentAndTabSubscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

  selectionChange(selectionIndex: number) {
    // PRE: the tab selection changes and this is passed the index of the tab
    // POST: sets the current tab
    this.spinnerService.showSpinner = true;
    setTimeout(() => {
      this.selectionIndex = selectionIndex;
      this.selectedTabName = this.tabNames[selectionIndex];
      setTimeout(() => {
        this.spinnerService.showSpinner = false;
      }, 100);
    }, 500);
  }

  clearFilter() {
    // POST: clears the filters from the current tab's table
    if (this.tableDataV9[this.selectionIndex]) {
      this.tableDataV9[this.selectionIndex].removeAllFilters();
      for (let i = 0; i < this.tableDataV9[this.selectionIndex].data.length; i++) {
        const subTable = this.tableDataV9[this.selectionIndex].data[i];
        if (subTable instanceof AssessmentDataCategory) {
          subTable.subTableData.removeAllFilters();
        }
      }
    }
  }

  // Methods
  getAssessmentsAndTabs(saveCall = false) {
    // POST: obtains the assessments and tabs, setting tab names and assessments
    // Preparing for processing
    this.processingTabs = true;
    this.assessmentAndTabSubscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
    this.assessmentAndTabSubscriptions = [];

    // Obtaining data
    const yearId = this.yearService.defaultYear.Id;
    this.assessmentAndTabSubscriptions.push(

      // Obtaining tabs
      this.assessmentService.getStudentAssessmentTabs(yearId).subscribe(tabs => {
        this.tabNames = [];
        tabs.forEach(tab => {
          this.tabNames.push(tab.DESCRIPTION);
        });
        this.tabs = tabs;

        // Changing to the first tab
        if (saveCall == false) {
          this.selectionIndex = 0;
          this.selectedTabName = this.tabNames[0];
        }


        // Obtaining assessments
        this.assessmentAndTabSubscriptions.push(
          this.assessmentService.getStudentAssessments(tabs).subscribe(assessments => {
            this.assessments = assessments;
            this.arrangeTabs(saveCall);
            this.processingTabs = false;
          })
        );
      })
    );
  }

  arrangeTabs(saveCall = false) {
    // PRE: the tabs and data are obtained
    // POST: arranges the data for display and sets the initial grid size
    this.arrangeTabsV9(saveCall);

    // If this is V9 and the first tab, we expand all
    setTimeout(() => {
      if (this.selectionIndex == 0) {
        this.toggleAllRows.emit(true);
      }
    }, 10);

    // Running change detection manually because we made a ton of changes
    this.changeDetector.detectChanges();
  }

  arrangeTabsV9(saveCall = false) {
    // PRE: Your user MUST be in V9, or this doesn't make sense
    // POST: finds the tabs and arranges the data for each tab
    this.tableDataV9 = [];
    const dataArrays: Array<Array<AssessmentDataCategory>> = new Array<Array<AssessmentDataCategory>>();

    // Creating a data category for each tab
    for (let i = 0; i < this.tabNames.length; i++) {
      dataArrays.push(new Array<AssessmentDataCategory>());
    }

    for (let i = 0; i < this.assessments.length; i++) {

      // Only operating on the assessment if we should display this
      if (this.assessments[i].Display) {

        // Determining where to place this data
        const tableIndex = this.tabNames.indexOf(this.assessments[i].FULLTITLE);
        const dataCategories = dataArrays[tableIndex];
        let categoryExists = false;
        let categoryIndex = -1;
        for (let j = 0; j < dataCategories.length; j++) {
          if (categoryIndex < 0 &&
            dataCategories[j].category == this.assessments[i].DESCRIPTION &&
            dataCategories[j].testName == this.assessments[i].FULLTITLE) {
            categoryExists = true;
            categoryIndex = j;
          }
        }
        const bestOfTableIndex = this.tabNames.indexOf('Best Of');
        const bestOfCategories = bestOfTableIndex >= 0 ? dataArrays[bestOfTableIndex] : null;
        let bestOfCategoryExists = false;
        let bestOfIndex = -1;
        if (bestOfCategories && this.assessments[i].BESTOF) {
          for (let j = 0; j < bestOfCategories.length; j++) {
            if (bestOfIndex < 0 &&
              bestOfCategories[j].category == this.assessments[i].DESCRIPTION &&
              bestOfCategories[j].testName == this.assessments[i].FULLTITLE) {
              bestOfCategoryExists = true;
              bestOfIndex = j;
            }
          }
        }

        // If not place was found, creating a new category for it
        if (!categoryExists) {
          dataCategories.push(new AssessmentDataCategory());
          categoryIndex = dataCategories.length - 1;
          const assessment = this.assessments[i];
          dataCategories[categoryIndex].category = assessment.DESCRIPTION;
          dataCategories[categoryIndex].testName = assessment.FULLTITLE;
          dataCategories[categoryIndex].fullTitle = assessment.DESCRIPTION;
          const dataFields = assessment.AssessmentDataField;
          if (dataFields != null && dataFields.length > 0) {
            dataCategories[categoryIndex].layoutVersionId = dataFields[0].TestMasterLayoutVersionId;
            dataCategories[categoryIndex].instanceId = dataFields[0].TestInstanceId;
          }
        }
        if (this.assessments[i].BESTOF && !bestOfCategoryExists) {
          bestOfCategories.push(new AssessmentDataCategory());
          bestOfIndex = bestOfCategories.length - 1;
          const assessment = this.assessments[i];
          bestOfCategories[bestOfIndex].category = this.assessments[i].DESCRIPTION;
          bestOfCategories[bestOfIndex].testName = this.assessments[i].FULLTITLE;
          bestOfCategories[bestOfIndex].fullTitle = this.assessments[i].FULLTITLE + ' - ' + this.assessments[i].DESCRIPTION;
          const dataFields = assessment.AssessmentDataField;
          if (dataFields != null && dataFields.length > 0) {
            bestOfCategories[categoryIndex].layoutVersionId = dataFields[0].TestMasterLayoutVersionId;
            bestOfCategories[categoryIndex].instanceId = dataFields[0].TestInstanceId;
          }
        }

        // Ensuring the correct category names
        this.assessments[i].AssessmentDataField.forEach(field => {
          if (!dataCategories[categoryIndex].fields.includes(field.strFieldName)) {
            dataCategories[categoryIndex].fields.push(field.strFieldName);
          }
          if (this.assessments[i].BESTOF) {
            if (!bestOfCategories[bestOfIndex].fields.includes(field.strFieldName)) {
              bestOfCategories[bestOfIndex].fields.push(field.strFieldName);
            }
          }
        });

        // Iterating through the data rows
        this.assessments[i].AssessmentsDataRows.forEach(dataRow => {

          // Creating dictionary for each data row
          const dictionaryData: { [key: string]: string } = {};
          dictionaryData['TestInstanceId'] = dataRow.AssessmentData[0].TestInstanceId.toString();
          dataRow.AssessmentData.forEach(data => {
            dictionaryData[data.strFieldName] = data.strFieldData;
          });

          // Adding it to our categories if it's not there (preventing duplicates)
          if (!dataCategories[categoryIndex].contains(dictionaryData)) {
            dataCategories[categoryIndex].data.push(dictionaryData);
          }
          if (this.assessments[i].BESTOF) {
            if (!bestOfCategories[bestOfIndex].contains(dictionaryData)) {
              bestOfCategories[bestOfIndex].data.push(dictionaryData);
            }
          }
        });
      }
    }

    // for new tab
    for (let t = 0; t < dataArrays.length; t++) {
      // *********************************************
      const temptestMaster = this.testMasters.find(x => x.Code == this.tabNames[t]);
      let temptestMasterLayoutVersion: TestMasterLayoutVersion[] = [];
      if (temptestMaster != null) {
        temptestMasterLayoutVersion = this.testMasterLayoutVersions.filter(x => x.TestMasterId == Number(temptestMaster.Id));
      }
      // *******************************************

      if (dataArrays[t].length == 0 || temptestMasterLayoutVersion.length != dataArrays[t].length) {

        // Determining where to place this data
        const tableIndex = t;
        const dataCategories = dataArrays[tableIndex];
        let categoryIndex = -1;

        const testMaster = this.testMasters.find(x => x.Code == this.tabNames[t]);
        let testMasterLayoutVersion: TestMasterLayoutVersion[] = [];
        if (testMaster != null) {
          testMasterLayoutVersion = this.testMasterLayoutVersions.filter(x => x.TestMasterId == Number(testMaster.Id));
        }

        for (let c = 0; c < testMasterLayoutVersion.length; c++) {
          const isExists = dataArrays[t].find(aa => aa.fullTitle == testMasterLayoutVersion[c].Description);
          if (!isExists) {
            dataCategories.push(new AssessmentDataCategory());
            categoryIndex = dataCategories.length - 1;
            dataCategories[categoryIndex].category = testMasterLayoutVersion[c].Description;
            dataCategories[categoryIndex].testName = testMasterLayoutVersion[c].Description;
            dataCategories[categoryIndex].fullTitle = testMasterLayoutVersion[c].Description;
            dataCategories[categoryIndex].instanceId = 0;
            dataCategories[categoryIndex].layoutVersionId = testMasterLayoutVersion[c].VersionId;
          }
        }
      }

      if (saveCall == true) {
        this.selectionChange(this.selectionIndex);
      }
    }

    // Making data arrays MatTableDataSources
    dataArrays.forEach(dataArray => {
      // Sorting them alphabetically initially
      dataArray.sort((a, b) => {
        if (a.fullTitle < b.fullTitle) {
          return -1;
        } else if (b.fullTitle < a.fullTitle) {
          return 1;
        } else {
          return 0;
        }
      });

      // Sorting each one by date
      dataArray.forEach(dataCategory => {
        dataCategory.sort('Test Date', new Date());
      });

      // Constructing the subtable data
      dataArray.forEach(data => {
        data.createSubTableData();
      });

      // Inserting into table data
      this.tableDataV9.push(new TylerMatTableDataSource(dataArray));
    });
  }

  tabTrackBy(index: number, item: Assessment) {
    return item.Id;
  }

  addTab() {
    const unSelectedTabs: Lookup[] = [];
    this.testMasters.forEach(t => {
      if (this.tabNames.indexOf(t.Code) == -1) {
        unSelectedTabs.push(t);
      }
    });
    const dialogRef = this.dialog.open(AddAssessmentTabDialogComponent, {
      height: '80vh',
      width: '25vw',
      disableClose: true,
      data: {
        tabs: unSelectedTabs
      }
    });
    dialogRef.afterClosed().subscribe((data: Lookup[]) => {
      if (data != undefined && data.length > 0) {
        data.forEach(tab => {
          const newtab = new Assessment();
          if (this.tabNames.indexOf(tab.Code) == -1) {
            this.tabNames.push(tab.Code);
            newtab.FULLTITLE = tab.Code;
            newtab.DESCRIPTION = tab.Code;
            newtab.Display = true;
            this.tabs.push(newtab);
          }
        });

        // Sorting them
        if (data.length > 0) {
          let tempTabs: Assessment[];
          tempTabs = this.tabs;
          this.tabs = [];

          let tampTabName = [];
          tampTabName = this.tabNames;
          this.tabNames = [];

          setTimeout(() => {
            this.tabs.push(tempTabs[0]);
            tempTabs = _.orderBy(tempTabs, ['DESCRIPTION'], ['asc']);
            tempTabs.forEach(tb => {
              if (this.tabs.find(x => x.DESCRIPTION == tb.DESCRIPTION) == null) {
                this.tabs.push(tb);
              }
            });

            this.tabNames.push(tampTabName[0]);
            tampTabName = tampTabName.sort((a, b) => (a > b ? 1 : -1));
            tampTabName.forEach(t => {
              if (this.tabNames.indexOf(t) == -1) {
                this.tabNames.push(t);
              }
            });
            this.arrangeTabs();
          }, 0);
        }
      }
    });
  }

  getAssessemntTabs(value) {
    if (value) {
      this.getAssessmentsAndTabs(true);
    }
  }

  studentViewMode() {
    if (this.router.url.toLowerCase().indexOf('registrationenrollment') > -1) {
      return false;
    }
    else {
      return true;
    }
  }

}
